import { render, staticRenderFns } from "./wxLogin.vue?vue&type=template&id=575160fe&scoped=true&"
import script from "./wxLogin.vue?vue&type=script&lang=js&"
export * from "./wxLogin.vue?vue&type=script&lang=js&"
import style0 from "./wxLogin.vue?vue&type=style&index=0&id=575160fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575160fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('575160fe')) {
      api.createRecord('575160fe', component.options)
    } else {
      api.reload('575160fe', component.options)
    }
    module.hot.accept("./wxLogin.vue?vue&type=template&id=575160fe&scoped=true&", function () {
      api.rerender('575160fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginPublic/wxLogin.vue"
export default component.exports